
import { useEffect, useState } from 'react';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';

export default function CerezPolitikasiPage() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <div className="min-h-screen bg-black text-white">
      <Header />
      
      <main className="pt-24">
        <div className="container-max py-16">
          <div className={`transition-all duration-1000 ${isVisible ? 'fade-in' : 'opacity-0'}`}>
            <h1 className="text-4xl md:text-5xl font-bold mb-8 text-center">
              <span className="gold-text">Çerez Politikası</span>
            </h1>
            <div className="w-24 h-1 gold-gradient mx-auto rounded-full mb-12"></div>
            
            <div className="max-w-4xl mx-auto space-y-8 text-gray-300">
              <section className="card-premium p-8">
                <h2 className="text-2xl font-bold gold-text mb-4">1. Çerez Nedir?</h2>
                <p className="leading-relaxed">
                  Çerezler, web sitelerini ziyaret ettiğinizde cihazınıza (bilgisayar, tablet, telefon) 
                  kaydedilen küçük metin dosyalarıdır. Çerezler, web sitesinin düzgün çalışmasını sağlar 
                  ve kullanıcı deneyimini iyileştirir.
                </p>
              </section>

              <section className="card-premium p-8">
                <h2 className="text-2xl font-bold gold-text mb-4">2. Çerez Türleri</h2>
                
                <div className="space-y-6">
                  <div>
                    <h3 className="text-xl font-semibold gold-text mb-2">Zorunlu Çerezler</h3>
                    <p className="leading-relaxed">
                      Web sitesinin temel işlevlerini yerine getirmesi için gerekli olan çerezlerdir. 
                      Bu çerezler olmadan web sitesi düzgün çalışmaz.
                    </p>
                  </div>

                  <div>
                    <h3 className="text-xl font-semibold gold-text mb-2">Performans Çerezleri</h3>
                    <p className="leading-relaxed">
                      Web sitesinin performansını ölçmek ve iyileştirmek için kullanılan çerezlerdir. 
                      Hangi sayfaların en çok ziyaret edildiği gibi bilgileri toplar.
                    </p>
                  </div>

                  <div>
                    <h3 className="text-xl font-semibold gold-text mb-2">İşlevsellik Çerezleri</h3>
                    <p className="leading-relaxed">
                      Kullanıcı tercihlerini hatırlamak ve kişiselleştirilmiş bir deneyim sunmak 
                      için kullanılan çerezlerdir.
                    </p>
                  </div>

                  <div>
                    <h3 className="text-xl font-semibold gold-text mb-2">Hedefleme/Reklam Çerezleri</h3>
                    <p className="leading-relaxed">
                      Kullanıcıların ilgi alanlarına göre özelleştirilmiş reklamlar göstermek 
                      için kullanılan çerezlerdir.
                    </p>
                  </div>
                </div>
              </section>

              <section className="card-premium p-8">
                <h2 className="text-2xl font-bold gold-text mb-4">3. Çerezlerin Kullanım Amaçları</h2>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Web sitesinin güvenli ve düzgün çalışmasını sağlamak</li>
                  <li>Kullanıcı deneyimini iyileştirmek</li>
                  <li>Web sitesi trafiğini analiz etmek</li>
                  <li>Kullanıcı tercihlerini hatırlamak</li>
                  <li>Kişiselleştirilmiş içerik sunmak</li>
                  <li>Sosyal medya entegrasyonu sağlamak</li>
                </ul>
              </section>

              <section className="card-premium p-8">
                <h2 className="text-2xl font-bold gold-text mb-4">4. Üçüncü Taraf Çerezleri</h2>
                <p className="leading-relaxed mb-4">
                  Web sitemizde aşağıdaki üçüncü taraf hizmetlerin çerezleri kullanılabilir:
                </p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Google Analytics - Web sitesi trafiği analizi</li>
                  <li>Google Maps - Harita hizmetleri</li>
                  <li>YouTube - Video içerik</li>
                  <li>Instagram - Sosyal medya entegrasyonu</li>
                  <li>WhatsApp - İletişim widget'ı</li>
                </ul>
              </section>

              <section className="card-premium p-8">
                <h2 className="text-2xl font-bold gold-text mb-4">5. Çerez Yönetimi</h2>
                <p className="leading-relaxed mb-4">
                  Çerezleri kontrol etmek ve yönetmek için aşağıdaki yöntemleri kullanabilirsiniz:
                </p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Tarayıcı ayarlarından çerezleri devre dışı bırakabilirsiniz</li>
                  <li>Mevcut çerezleri silebilirsiniz</li>
                  <li>Çerez kabul etmeden önce uyarı alacak şekilde ayarlayabilirsiniz</li>
                  <li>Belirli web sitelerinden gelen çerezleri engelleyebilirsiniz</li>
                </ul>
              </section>

              <section className="card-premium p-8">
                <h2 className="text-2xl font-bold gold-text mb-4">6. Tarayıcı Ayarları</h2>
                <div className="space-y-4">
                  <div>
                    <h3 className="text-lg font-semibold gold-text mb-2">Chrome</h3>
                    <p className="text-sm">Ayarlar &gt; Gelişmiş &gt; Gizlilik ve güvenlik &gt; Site ayarları &gt; Çerezler</p>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold gold-text mb-2">Firefox</h3>
                    <p className="text-sm">Seçenekler &gt; Gizlilik ve Güvenlik &gt; Çerezler ve Site Verileri</p>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold gold-text mb-2">Safari</h3>
                    <p className="text-sm">Tercihler &gt; Gizlilik &gt; Çerezler ve web sitesi verileri</p>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold gold-text mb-2">Edge</h3>
                    <p className="text-sm">Ayarlar &gt; Site izinleri &gt; Çerezler ve site verileri</p>
                  </div>
                </div>
              </section>

              <section className="card-premium p-8">
                <h2 className="text-2xl font-bold gold-text mb-4">7. İletişim</h2>
                <p className="leading-relaxed">
                  Çerez politikamız hakkında sorularınız için clearalignerbox@gmail.com 
                  e-posta adresinden bizimle iletişime geçebilirsiniz.
                </p>
              </section>

              <section className="card-premium p-8">
                <h2 className="text-2xl font-bold gold-text mb-4">8. Politika Güncellemeleri</h2>
                <p className="leading-relaxed">
                  Bu çerez politikası zaman zaman güncellenebilir. Güncellemeler web sitemizde 
                  yayınlandığı tarihte yürürlüğe girer. Düzenli olarak bu sayfayı kontrol etmenizi öneririz.
                </p>
                <p className="text-sm text-gray-400 mt-4">
                  Son güncelleme: {new Date().toLocaleDateString('tr-TR')}
                </p>
              </section>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
